(function(){
  var form = document.getElementById('ebf-tdeeForm');
  if(!form) return;
  var unitToggle = document.getElementById('ebf-unitToggle');
  var metricFields = document.getElementById('ebf-metricFields');
  var imperialFields = document.getElementById('ebf-imperialFields');
  var results = document.getElementById('ebf-calcResults');
  var unit = 'metric';

  unitToggle.addEventListener('click', function(e){
    var btn = e.target.closest('button');
    if(!btn) return;
    unit = btn.dataset.unit;
    unitToggle.querySelectorAll('button').forEach(function(b){ b.classList.toggle('active', b === btn); });
    metricFields.style.display = unit === 'metric' ? '' : 'none';
    imperialFields.style.display = unit === 'imperial' ? '' : 'none';
  });

  var activityMap = {
    sedentary: 1.2,
    light: 1.375,
    moderate: 1.55,
    active: 1.725,
    veryactive: 1.9
  };

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var sex = document.getElementById('ebf-tdee-sex').value;
    var age = parseFloat(document.getElementById('ebf-tdee-age').value);
    var activity = document.getElementById('ebf-tdee-activity').value;
    var heightCm, weightKg;

    if(unit === 'metric'){
      heightCm = parseFloat(document.getElementById('ebf-tdee-height-cm').value);
      weightKg = parseFloat(document.getElementById('ebf-tdee-weight-kg').value);
    } else {
      var ft = parseFloat(document.getElementById('ebf-tdee-height-ft').value) || 0;
      var inch = parseFloat(document.getElementById('ebf-tdee-height-in').value) || 0;
      var lb = parseFloat(document.getElementById('ebf-tdee-weight-lb').value) || 0;
      heightCm = (ft * 12 + inch) * 2.54;
      weightKg = lb * 0.453592;
    }

    if(!heightCm || !weightKg || !age){ return; }

    var bmr = sex === 'male'
      ? (10 * weightKg) + (6.25 * heightCm) - (5 * age) + 5
      : (10 * weightKg) + (6.25 * heightCm) - (5 * age) - 161;

    var tdee = bmr * (activityMap[activity] || 1.2);

    var cut = Math.round(tdee - 500);
    var maintain = Math.round(tdee);
    var bulk = Math.round(tdee + 300);

    results.innerHTML =
      '<h3>Your Numbers</h3>' +
      '<div class="sub">Based on the Mifflin-St Jeor formula</div>' +
      '<div class="ebf-bmr-tdee"><span>BMR</span><b>' + Math.round(bmr) + ' kcal</b></div>' +
      '<div class="ebf-bmr-tdee"><span>TDEE</span><b>' + Math.round(tdee) + ' kcal</b></div>' +
      '<div class="ebf-goal-row highlight">' +
        '<div><div class="g-label">Fat Loss</div><div class="g-sub">~0.5kg/week deficit</div></div>' +
        '<div class="g-val">' + cut + '</div>' +
      '</div>' +
      '<div class="ebf-goal-row">' +
        '<div><div class="g-label">Maintain</div><div class="g-sub">hold current weight</div></div>' +
        '<div class="g-val">' + maintain + '</div>' +
      '</div>' +
      '<div class="ebf-goal-row">' +
        '<div><div class="g-label">Muscle Gain</div><div class="g-sub">lean bulk surplus</div></div>' +
        '<div class="g-val">' + bulk + '</div>' +
      '</div>';
  });
})();
